import { AppDownloadsData } from '~stores/onboarding';

/**
 * The notes under the "Application download" card.
 *
 * A single date, not one per platform: the card's headline is the two stores'
 * totals summed, and that sum is only complete up to the less fresh of them, so
 * the store hands down the older of the two `dataCompleteThrough` dates and the
 * card shows that one. With a platform missing there is no such bound, so the
 * store hands down nothing and only the reason shows, which is what explains the
 * placeholder in place of a figure.
 */
export const getAppDownloadInfoLines = (
    appDownloadsData: AppDownloadsData | null
): string[] => {
    if (!appDownloadsData) {
        return [];
    }

    return [
        appDownloadsData.unavailableReason,
        appDownloadsData.dataCompleteThrough
            ? `Data available until ${appDownloadsData.dataCompleteThrough}`
            : null,
    ].filter((line): line is string => Boolean(line));
};
